__turbopack_context__.v({
  "chip": "AspectRatioCard-module-scss-module__qD4-9G__chip",
  "content": "AspectRatioCard-module-scss-module__qD4-9G__content",
  "footer": "AspectRatioCard-module-scss-module__qD4-9G__footer",
  "gradient": "AspectRatioCard-module-scss-module__qD4-9G__gradient",
  "header": "AspectRatioCard-module-scss-module__qD4-9G__header",
  "inView": "AspectRatioCard-module-scss-module__qD4-9G__inView",
});
